declare const __BPS_BUILD_PIPELINE__: string | undefined;
declare const __BPS_BUILD_COMMIT__: string | undefined;
declare const __BPS_BUILD_BRANCH__: string | undefined;

export interface BuildInfoMetadata {
  pipeline?: string;
  commit?: string;
  branch?: string;
}

interface BuildInfoTarget {
  getBuildInfo?: () => string;
}

const FALLBACK_PIPELINE = 'local';
const FALLBACK_COMMIT = 'unknown';
const FALLBACK_BRANCH = 'local';

const clean = (value: string | undefined, fallback: string): string => {
  const trimmed = value?.trim();
  return trimmed || fallback;
};

const readBuildConstant = (value: string | undefined): string | undefined => {
  const trimmed = value?.trim();
  return trimmed || undefined;
};

const readEnvValue = (key: string): string | undefined => {
  const env = import.meta.env as Record<string, string | undefined>;
  return readBuildConstant(env[key]);
};

export const formatBuildInfo = ({ pipeline, commit, branch }: BuildInfoMetadata): string => {
  const buildPipeline = clean(pipeline, FALLBACK_PIPELINE);
  const buildCommit = clean(commit, FALLBACK_COMMIT);
  const buildBranch = clean(branch, FALLBACK_BRANCH);

  return `Build ${buildPipeline}-${buildCommit}, built from ${buildBranch} @ ${buildCommit} (Pipeline #${buildPipeline})`;
};

export const getBuildMetadata = (): BuildInfoMetadata => ({
  pipeline:
    readBuildConstant(typeof __BPS_BUILD_PIPELINE__ === 'undefined' ? undefined : __BPS_BUILD_PIPELINE__) ?? readEnvValue('VITE_BUILD_PIPELINE'),
  commit: readBuildConstant(typeof __BPS_BUILD_COMMIT__ === 'undefined' ? undefined : __BPS_BUILD_COMMIT__) ?? readEnvValue('VITE_BUILD_COMMIT'),
  branch: readBuildConstant(typeof __BPS_BUILD_BRANCH__ === 'undefined' ? undefined : __BPS_BUILD_BRANCH__) ?? readEnvValue('VITE_BUILD_BRANCH'),
});

export const getBuildInfo = (): string => formatBuildInfo(getBuildMetadata());

export const registerBuildInfo = (target: BuildInfoTarget, buildInfoGetter: () => string = getBuildInfo): void => {
  target.getBuildInfo = buildInfoGetter;
};

declare global {
  interface Window {
    getBuildInfo: () => string;
  }
}
